import styled from 'styled-components';

import colors from '../../../../styles/colors';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 11px;
  border: 1px solid ${colors.addAlpha(colors.shades.success8, 0.4)};
  background: ${colors.addAlpha(colors.shades.success8, 0.1)};
  white-space: nowrap;
  font-size: 10px;
  line-height: 12px;
`;

const PreviousValue = styled.span`
  color: ${colors.shades.gamma8};
  text-decoration: line-through;
`;

const Arrow = styled.span`
  color: ${colors.shades.gamma8};
  font-size: 10px;
`;

const CurrentValue = styled.span`
  color: ${colors.shades.success8};
  font-weight: 600;
`;

export {
  Badge,
  PreviousValue,
  Arrow,
  CurrentValue,
};
